import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function CountdownBar() {
  // 3 hours in seconds
  const [timeLeft, setTimeLeft] = useState(10800);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="w-full bg-[#2D2D3F] text-white py-3 px-4 shadow-md relative z-20 border-b border-white/10" data-id="element-25">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 text-center md:text-left" data-id="element-26">
        <div className="flex flex-col items-center md:items-start" data-id="element-27">
          <span className="text-[#FFD166] font-bold text-sm md:text-base uppercase tracking-wider flex items-center gap-2" data-id="element-28">
            ⭐ Oferta especial por tiempo limitado
          </span>
          <span className="text-gray-300 text-xs md:text-sm mt-0.5" data-id="element-29">
            Aprovechá el Mega Pack a $29.990 antes de que termine esta promoción
          </span>
        </div>

        <div className="flex items-center gap-2 bg-white/10 px-4 py-1.5 rounded-full mt-1 md:mt-0 border border-white/20 shadow-inner" data-id="element-30">
          <ClockIcon className="w-4 h-4 text-[#FFD166]" data-id="element-31" />
          <div className="font-mono font-bold text-lg tracking-wider text-white" data-id="element-32">
            {formatTime(hours)}:{formatTime(minutes)}:{formatTime(seconds)}
          </div>
        </div>
      </div>
    </div>;
}